<div class="sms-terms">
  <div class="container">
    <div class="row mt mt-3">
      <div class="col-12 text-center h3">SMS Terms of Service</div>
      <div class="col-12 text-center text-secondary">
        Effective Date: May 04, 2026
      </div>
    </div>

    <div class="row mt-3">
      <div class="col-12">
        These SMS Terms of Service ("SMS Terms") govern your participation in
        the text-messaging program operated by Universal Processing LLC d/b/a
        uOrder ("we," "us," or "our") for sending a one-time order- or
        payment-related SMS to customers who place orders through the uOrder
        online-ordering platform. By providing your mobile number at checkout
        and ticking the SMS consent checkbox, you agree to these SMS Terms
        and to our
        <a href="https://www.uorder.io/privacy-policy">Privacy Policy</a>.
      </div>

      <div class="col-12 h6 mt-4">1. Program Name</div>
      <div class="col-12">
        uOrder Order &amp; Payment SMS (operated by Universal Processing LLC).
      </div>

      <div class="col-12 h6 mt-4">2. Program Description</div>
      <div class="col-12">
        This program sends a single transactional, one-time SMS to customers
        who place an order on the uOrder platform and explicitly opt in at
        checkout. The SMS contains either information about the customer's
        order (such as an order confirmation) or a payment link associated
        with the order. At checkout, the customer enters a mobile number into
        the phone-number field on the checkout form and ticks the SMS consent
        checkbox shown directly beneath that field. The checkbox is unchecked
        by default. The disclosure text displayed adjacent to the checkbox
        reads: "Yes, send me a one-time order- or payment-related SMS at this
        number. Msg &amp; data rates may apply. Reply STOP to opt out, HELP
        for help. By checking, you agree to our SMS Terms and Privacy Policy."
      </div>
      <div class="col-12 mt-2">
        When the customer ticks the box and submits the order, we send ONE
        SMS in connection with that order. We do not send any further SMS to
        the customer in connection with that consent, do not add the number
        to any contact or marketing list, and do not use the number for any
        future messaging. The mobile number is retained only on the
        order/consent record and is not added to the customer's account
        profile.
      </div>
      <div class="col-12 mt-2">
        This program is transactional and operational. We do not send
        marketing messages through this program.
      </div>

      <div class="col-12 mt-3">
        <b>Sample messages:</b>
        <ul class="ps-4 mt-2">
          <li>
            "uOrder: Order #1234 confirmed at Joe's Pizza. Reply STOP to opt
            out, HELP for help. Msg&amp;data rates may apply."
          </li>
          <li>
            "uOrder: Complete your order at Joe's Pizza:
            https://pay.uorder.io/abc123. Reply STOP to opt out, HELP for
            help. Msg&amp;data rates may apply."
          </li>
        </ul>
      </div>

      <div class="col-12 h6 mt-4">3. Message Frequency</div>
      <div class="col-12">One SMS per order placed with consent.</div>

      <div class="col-12 h6 mt-4">4. Message and Data Rates</div>
      <div class="col-12">
        Message and data rates may apply. Check your wireless plan for details.
        We are not responsible for any charges from your wireless carrier.
      </div>

      <div class="col-12 h6 mt-4">5. How to Opt Out &mdash; STOP</div>
      <div class="col-12">
        <b>Reply STOP to any message you receive from us to unsubscribe.</b>
      </div>
      <div class="col-12 mt-2">
        After you text STOP, we will send a one-time confirmation message that
        you have been unsubscribed, and you will receive no further messages
        from this program. Customers receive only a single one-shot SMS per
        order placed with consent; replying STOP suppresses any future order-
        or payment-related SMS to that number.
      </div>

      <div class="col-12 h6 mt-4">6. How to Get Help &mdash; HELP</div>
      <div class="col-12">
        <b
          >Reply HELP to any message for assistance, or contact us at
          <a href="mailto:support&#64;uorder.io">support&#64;uorder.io</a> or
          888-885-8840.</b
        >
      </div>

      <div class="col-12 h6 mt-4">
        7. Supported Carriers / Carrier Disclaimer
      </div>
      <div class="col-12">
        Supported carriers include AT&amp;T, T-Mobile, Verizon Wireless,
        Sprint, Boost, U.S. Cellular, MetroPCS, and most other U.S. carriers.
        Carriers are not liable for delayed or undelivered messages. Delivery
        of messages is subject to effective transmission by your wireless
        provider and is not guaranteed.
      </div>

      <div class="col-12 h6 mt-4">8. Privacy</div>
      <div class="col-12">
        We respect your privacy. We will not share your mobile information with
        third parties or affiliates for marketing or promotional purposes.
        Information sharing with subcontractors that help us deliver the SMS
        Services (specifically our SMS aggregator Twilio Inc.) is permitted
        solely for the purpose of transmitting the messages you request.
        Text-messaging originator opt-in data and consent will not be shared
        with any third parties. For complete details, see our
        <a href="https://www.uorder.io/privacy-policy">Privacy Policy</a>.
      </div>

      <div class="col-12 h6 mt-4">9. Eligibility</div>
      <div class="col-12">
        You must be at least 18 years old and the account holder of, or have
        permission from the account holder of, the mobile number you provide.
      </div>

      <div class="col-12 h6 mt-4">10. Changes to These SMS Terms</div>
      <div class="col-12">
        We may update these SMS Terms from time to time. Material changes will
        be posted at this URL with an updated Effective Date.
      </div>

      <div class="col-12 h6 mt-4">11. Contact</div>
      <div class="col-12">
        <ul class="ps-4">
          <li>Universal Processing LLC</li>
          <li>215 W 40th St Floor 8, New York, NY 10018</li>
          <li>Email: <a href="mailto:support&#64;uorder.io">support&#64;uorder.io</a></li>
          <li>Phone: 888-885-8840</li>
        </ul>
      </div>
    </div>
  </div>
</div>
